import React, { useEffect, useState } from 'react'
import { GxIcon } from '@garpix/garpix-web-components-react'
import Section from '@/components/Section'
import Title from '@/components/Title'
import {
  educationIcon,
  locationIcon,
  mailIcon,
  phoneIcon,
  webIcon
} from '@/images'
import { formatPhoneNumber, removeHttp } from '@/utils'
import style from '../styles/inst_detail.module.scss'
import HtmlContent from '@/components/HtmlContent'

interface IProps {
  logo: string | null
  name: string
  state: string
  address: string
  site: string
  description: string
  level: string
  phone: string
  email: string
}

const Head = ({
  logo,
  name,
  state,
  address,
  site,
  description,
  level,
  phone,
  email
}: IProps): React.ReactElement => {
  const [fullAddress, setFullAddress] = useState(state)
  const siteHostname = removeHttp(site)
  const formattedPhone = formatPhoneNumber(phone)

  useEffect(() => {
    if (address !== '' && address !== null) {
      setFullAddress(state + ', ' + address)
    } else {
      setFullAddress(state)
    }
  }, [address, state])

  return (
    <Section>
      <div className={style.head}>
        {logo === null
          ? (
            <div className={style.head__empty}>
              <GxIcon src={educationIcon} className={style.head__empty_icon} />
            </div>
            )
          : (
            <img
              src={logo}
              width='145px'
              height='233px'
              alt={name}
              className={style.head__logo}
            />
            )}

        <div className={style.head_top}>
          {state !== ''
            ? (
              <span className={style.head__location}>
                <GxIcon src={locationIcon} className={style.head__icon} />
                {state}
              </span>
              )
            : null}

          {siteHostname !== ''
            ? (
              <a
                href={site}
                target='_blank'
                rel='nofollow noopener noreferrer'
                className={style.head__link}
              >
                <GxIcon src={webIcon} className={style.head__icon} />
                {siteHostname}
              </a>
              )
            : null}
        </div>
        <Title type='h2' theme='h1'>
          {name}
        </Title>
      </div>

      <Title type='h3' className={style.desc__title}>
        Описание
      </Title>

      <HtmlContent content={description} className={style.desc__text} />

      <div className={style.desc_info}>
        <div className={style.desc_left}>
          {level !== ''
            ? (
              <span className={style.desc__item}>
                <GxIcon src={educationIcon} className={style.head__icon} />
                {level}
              </span>
              )
            : null}
          {fullAddress !== ''
            ? (
              <span className={style.desc__item}>
                <GxIcon src={locationIcon} className={style.head__icon} />
                {fullAddress}
              </span>
              )
            : null}
        </div>

        <div className={style.desc_right}>
          {siteHostname !== ''
            ? (
              <a
                href={site}
                target='_blank'
                rel='nofollow noopener noreferrer'
                className={style.desc__link}
              >
                <GxIcon src={webIcon} className={style.head__icon} />
                {siteHostname}
              </a>
              )
            : null}
          {email !== '' && email !== null
            ? (
              <a
                href={`mailto:${email}`}
                target='_blank'
                rel='nofollow noopener noreferrer'
                className={style.desc__link}
              >
                <GxIcon src={mailIcon} className={style.head__icon} />
                {email}
              </a>
              )
            : null}
          {formattedPhone !== ''
            ? (
              <a
                href={`tel:+${phone}`}
                target='_blank'
                rel='nofollow noopener noreferrer'
                className={style.desc__link}
              >
                <GxIcon src={phoneIcon} className={style.head__icon} />
                {formattedPhone}
              </a>
              )
            : null}
        </div>
      </div>
    </Section>
  )
}

export default Head
